import React from 'react';
import PropTypes from 'prop-types';
import Maybe from 'react-maybe';
import { Icon } from '@ers/ui';

const FileImage = ({ file: { url, name } }) => <Maybe of={url} either={<img src={url} alt={name} className="icon icon--file" />} orElse={<Icon name="file" file />} />;

FileImage.propTypes = {
    file: PropTypes.shape({ name: PropTypes.string, size: PropTypes.number, url: PropTypes.string })
};
FileImage.defaultProps = {
    file: PropTypes.shape({ name: null, size: null, url: 'null' })
};
export default FileImage;
